import { AxiosRequest } from "../common/axios-request"
import { CREATE_ORDER, GET_ORDER_AMOUNT, GET_ORDER_INVOICE, GET_RENTED_ORDER_LIST, GET_SOLD_ORDER_LIST, VALIDATE_ORDER_USER } from "../common/constant"

const GetOrderAmount = (payload: any) => {
    return AxiosRequest.post(GET_ORDER_AMOUNT, payload)
}

const CreatePosOrder = (payload: any) => {
    return AxiosRequest.post(CREATE_ORDER, payload)
}

const GetOrderInvoice = (id: string) => {
    return AxiosRequest.get(GET_ORDER_INVOICE.replace(":id", id))
}

const ValidateOrderUser = (payload: any) => {
    return AxiosRequest.post(VALIDATE_ORDER_USER, payload)
}

const GetSoldOrderList = (data: any) => {
    const { page, facilityId, key, fromDate, toDate } = data
    return AxiosRequest.get(GET_SOLD_ORDER_LIST(page, facilityId, key, fromDate, toDate))
}

const GetRentedOrderList = (data: any) => {
    const { page, facilityId, key, fromDate, toDate } = data
    return AxiosRequest.get(GET_RENTED_ORDER_LIST(page, facilityId, key, fromDate, toDate))
}

export { GetOrderAmount, CreatePosOrder, GetOrderInvoice, ValidateOrderUser, GetSoldOrderList, GetRentedOrderList }